import { useParams } from 'react-router-dom'
import DatahubDefaultEventUtils from 'src/utils/datahubDefaultEvent/datahubDefaultEvent'
import { SendDatahubDefaultEventsProps } from 'src/utils/datahubDefaultEvent/datahubDefaultEvent.types'
import {
  ClubVersion,
  System,
  UserRole
} from 'src/utils/datahubDefaultEvent/datahubDefaultEvent.enums'
import { useSessionData } from '../useSessionData'
import { useMembershipData } from '../useMembershipData'
// import { useUserSessionData } from '../useUserSessionData'
import { PathParams } from './useSendDatahubDefaultEvents.types'

/**
 * Custom hook for sending events to the datahub.
 *
 * utilities -> src/utils/datahubDefaultEvent
 * taxonomy table -> https://docs.google.com/spreadsheets/d/1dTq-dLf_q3_FjXGWk3RTgmHDJxRvfXxTQoeRwxJykyg/edit#gid=1951505218
 *
 * @example
 * const { dispatchDatahubDefaultEvents } = useSendDatahubDefaultEvents();
 *
 * dispatchDatahubDefaultEvents({
 *  system: System.HOTMART_CLUB,
 *  action: Action.CLICK,
 *  entity: Entity.COMMUNITY,
 *  event: {
 *    communityId: Number(post?.communityId)
 *  }
 * });
 */
const useSendDatahubDefaultEvents = () => {
  const sessionData = useSessionData()
  // const { data } = useUserSessionData()
  const { membership: membershipSlug } = useParams() as PathParams
  const { data: membership } = useMembershipData({
    slug: membershipSlug
  })

  const dispatchDatahubDefaultEvents = ({
    system = System.HOTMART_CLUB,
    entity,
    action,
    event
  }: SendDatahubDefaultEventsProps) => {
    const platformDetail =
      window.navigator?.userAgentData?.platform || window.navigator?.platform || 'unknown'

    const osVersion = window.navigator?.userAgent || window.navigator?.appVersion || 'unknown'

    /**
     * For users not logged send `"userId": 0` and `"ucode": "X"`
     */
    const userData = {
      userId: sessionData?.user?.id || 0,
      ucode: sessionData?.user?.ucode || 'X',
      isLogged: Boolean(sessionData?.user?.isLogged),
      //userRole: data?.role || UserRole.VIEWER
      userRole: UserRole.VIEWER
    }

    const membershipData = {
      membershipId: membership?.id || sessionData?.membership?.id || 'UNDEFINED',
      membershipSlug: membership?.slug || sessionData?.membership?.slug || 'UNDEFINED'
    }

    DatahubDefaultEventUtils.sendEvent(
      {
        entity,
        action,
        event: {
          platformDetail,
          osVersion,
          url: window.location.href,
          appVersion: process.env.PROJECT_VERSION,
          clubVersion: ClubVersion.MEMBERSHIP,
          screenName: 'NOT_APP_EVENT',
          sessionId: 'X',
          ...userData,
          ...membershipData,
          ...event
        }
      },
      system
    )
  }

  return { dispatchDatahubDefaultEvents }
}

export default useSendDatahubDefaultEvents
